import { AfterViewInit, ChangeDetectorRef, Component, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ExperiencesService } from '../experiences.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-experience',
  templateUrl: './add-experience.component.html',
  styleUrls: ['./add-experience.component.scss']
})
export class AddExperienceComponent implements OnInit {

  requiredNext = false;
  
  pickerPlaceholderColor = '#FFFFFF';

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate;
  toDate: NgbDate | null = null;

  mapType = null;

  experienceForm = new FormGroup({
    titolo: new FormControl('', [Validators.required]),
    descrizione: new FormControl('', [Validators.required]),
    info: new FormControl(''),
    video: new FormControl(''),
    tipologia: new FormControl('gioco', [Validators.required]),
    featuredImage: new FormControl(null, [Validators.required]),
    primaryColor: new FormControl('#73BCCA', [Validators.required]),
    hasPeriod: new FormControl(false, [Validators.required]),
    startDate: new FormControl('', [Validators.required]),
    endDate: new FormControl('', [Validators.required]),
    fixedOrder: new FormControl(false),
    mapType: new FormControl('disabled'),
    imageMap: new FormControl(''),
    hasPrizes: new FormControl(false)
  });


  constructor(
    private expService: ExperiencesService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  // convenience getter for easy access to form fields
  get f(): any {
    return this.experienceForm.controls;
  }

  validateConfigurazione(): boolean {
    if (this.f.titolo.errors  || this.f.descrizione.errors || this.f.tipologia.errors) {
      return false;
    } else {
      return true;
    }
  }

  validateAspetto(): boolean {
    if (this.f.featuredImage.errors || this.f.primaryColor.errors) {
      return false;
    } else {
      return true;
    }
  }

  validatePeriodo(): boolean {
    if (this.f.hasPeriod.value) {
      if (this.f.startDate.errors || this.f.endDate.errors) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  validateNavigazione(): boolean {
    if (this.f.fixedOrder.errors) {
      return false;
    } else if (this.f.mapType.errors) {
      return false;
    } else if (this.f.mapType.value === 'image') {
      if (this.f.imageMap.errors) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  validatePremi(): boolean {
    return true;
    /* if (this.f.startDate.errors || this.f.endDate.errors) {
      return false;
    } else {
      return true;
    } */
  }

  onDateSelection(date: NgbDate): void {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
      this.f.startDate.setValue(date.day + '-' + date.month + '-' + date.year);
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
      this.f.endDate.setValue(date.day + '-' + date.month + '-' + date.year);
    } else {
      this.toDate = null;
      this.f.endDate.setValue(null);
      this.fromDate = date;
      this.f.startDate.setValue(date.day + '-' + date.month + '-' + date.year);
    }
  }

  isHovered(date: NgbDate): boolean {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate): boolean {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate): boolean {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  colorPickerPlaceholderLight(color): void {
    const c = color.substring(1);      // strip #
    const rgb = parseInt(c, 16);   // convert rrggbb to decimal
    const r = (rgb >> 16) & 0xff;  // extract red
    const g = (rgb >>  8) & 0xff;  // extract green
    const b = (rgb >>  0) & 0xff;  // extract blue
    const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

    if (luma < 100) {
      this.pickerPlaceholderColor = '#ffffff';
    } else {
      this.pickerPlaceholderColor = '#333333';
    }
  }

  setImageUrl(event, formControl): void {
    this.f[formControl].setValue(event? event.filename : null);
  }

  saveExperience(): void {
    const newExp = {
      title: this.f.titolo.value,
      description: this.f.descrizione.value,
      extra: {
        info: this.f.info.value,
        video: this.f.video.value,
        type: this.f.tipologia.value
      },
      image: this.f.featuredImage.value,
      startDate: this.f.hasPeriod.value ? moment(this.f.startDate.value, 'DD-MM-YYYY').format('YYYY-MM-DD HH:mm:ss') : null,
      endDate: this.f.hasPeriod.value ? moment(this.f.endDate.value, 'DD-MM-YYYY').format('YYYY-MM-DD HH:mm:ss'): null,
      styleData: {
        primaryColor: this.f.primaryColor.value
      },
      fixedOrder: this.f.fixedOrder.value,
      mapType: this.f.mapType.value,
      mapData: this.f.mapType.value === 'image' ? {imagePath: this.f.imageMap.value} : null,
      hasPrizes: this.f.hasPrizes.value,
      status: 'offline'
    };

    this.expService.addNewExperience(newExp)
    .subscribe((res: {data: any, message: string}) => {
      this.router.navigate(['/experiences', res.data.id]);
    });
  }


}
